<template>
	<div class="app-button space-between"
	>
		<span class="button-text"
			@click.prevent="buttonClicked"
		>{{item.name}}</span>
		<div class="flex-style">
			<app-tooltip-button
				v-for="(icon, indexIcon) in filterIcons"
				:key="indexIcon"
				:icon="icon.name"
				:color="dinamicColor(icon)"
				:text="icon.text"
				@click-icon="iconAction(icon)"
			/>
		</div>
	</div>
</template>
<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import lib from '@/lib';

const { matchBetweenArrays } = lib;

function filterIcons() {
	return matchBetweenArrays([this.iconsToUse], [this.icons, 'flag']);
}

function dinamicColor({ color, flag }) {
	if (flag === 'edit') {
		return this.active ? 'white' : color;
	}
	return color;
}

function buttonClicked() {
	this.$emit('button-clicked', this.item);
}

function iconAction(icon) {
	const { name } = icon;
	const opt = {
		edit: 'edit-button',
		highlight_off: 'erase-configuration',
	};
	this.$emit(opt[name], this.item);
}

function data() {
	return {
		icons: [
			{ name: 'edit', color: 'success', text: 'editar', flag: 'edit' },
			{ name: 'highlight_off', color: 'error', text: 'borrar configuración', flag: 'close' },
		],
	};
}

export default {
	name: 'app-button',
	components: {
		appTooltipButton,
	},
	computed: {
		filterIcons,
	},
	data,
	methods: {
		buttonClicked,
		dinamicColor,
		iconAction,
	},
	props: {
		active: {
			default: false,
			type: Boolean,
		},
		item: {
			deafult: () => {},
			type: Object,
		},
		iconsToUse: {
			default: () => [],
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
.app-button {
	align-items: center;
	background-color: map-get($colors, bgGrey);
	border: 1px solid map-get($colors, bgGrey);
	border-radius: 8px;
	display: flex;
	height: 37px;
	padding: 8px 10px;
}

.app-button:hover {
	background-color: map-get($colors, bgGreyHover);
	border: 1px solid map-get($colors, bgGreyHover);
}

.button-text {
	cursor: pointer;
	white-space: nowrap;
}
</style>




// WEBPACK FOOTER //
// src/components/shared/app-button.vue